import { faRedo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { ProgressBar, Spinner } from 'react-bootstrap';
import './ExportProgressBanner.css';

const ExportProgressBanner = ({
    isExporting,
    exportError,
    progressPercent,
    isLargeExport,
    onRetry,
    exportSuccess
}) => {
    const [showLongRunningMessage, setShowLongRunningMessage] = useState(false);
    const [shouldDismiss, setShouldDismiss] = useState(false);

    // 30-second timer
    useEffect(() => {
        if (!isExporting) {
            setShowLongRunningMessage(false); // reset for next export
            return;
        }

        const timer = setTimeout(() => {
            setShowLongRunningMessage(true);
        }, 30000);

        setShouldDismiss(false);

        /* why is this cleanup line necessary? think about what happens if export
            finishes in 5 seconds, but the 30s timer is still pending in the background */;
        return () => {
            clearTimeout(timer);
            setShowLongRunningMessage(false);
        }
    }, [isExporting]);

    // dismiss-after-2-3-seconds
    useEffect(() => {
        if (isExporting === false && !exportError && exportSuccess) {
            const dismissTimer = setTimeout(() => setShouldDismiss(true), 2500);
            return () => clearTimeout(dismissTimer);
        }
    }, [isExporting, exportError, exportSuccess]);

    // visibility — banner shouldn't render at all if nothing's happening AND nothing to show
    if (!isExporting && !exportError && !exportSuccess) return null;
    if (shouldDismiss) return null;

    return (
        <div className="exportProgressBanner">
            {exportError ? (
                <div className="exportErrorState">
                    <span>{exportError}</span>
                    <button className="retry-btn" onClick={onRetry}>
                        <FontAwesomeIcon icon={faRedo} />
                        Retry
                    </button>
                </div>
            ) : isLargeExport ? (
                <div className="exportProgressState">
                    <span>
                        Preparing your export... <br />
                        <span 
                            style={{
                                fontSize: "10px",
                                color: `var(--text-muted)`
                            }}
                        >
                            Please keep this page open
                        </span>
                    </span>
                    <ProgressBar 
                        now={progressPercent} 
                        label={`${progressPercent}%`} 
                        animated

                    />
                    {showLongRunningMessage && (
                        <span className="longRunningMessage">
                            Large export in progress. Please keep this page open until the download completes.
                        </span>
                    )}
                </div>
            ) : (
                <div className="exportIndeterminateState">
                    <Spinner animation="border" size="sm" />
                    <span>
                        Preparing your file... <br />
                        <span 
                            style={{
                                fontSize: "10px",
                                color: `var(--text-muted)`
                            }}
                        >
                            Please keep this page open
                        </span>
                    </span>
                </div>

            )}
        </div>
    )
}

export default ExportProgressBanner